mutation deleteUsDueDiligenceNote($id: ID!) {
  deleteUsDueDiligenceNote(input: { id: $id }) {
    success
  }
}
